import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from '../create/index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';
import {  showError, showSuccess } from 'utils';
import {  getSubscriptionDetail, updateSubscription } from 'services';

const validationSchema = yup.object().shape({
  name: yup.string().required('Please enter name'),
  enName: yup.string(),
  description: yup.string().required('Please enter description'),
  enDescription: yup.string(),
});

type FormData = {
  name: string;
  enName: string;
  description: string;
  enDescription: string;
};

const EditSubscription = props => {
  const { subscriptionId } = props.match.params;
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState() as any;
  
  const {
    register,
    handleSubmit,
    errors,
    setValue,
  } = useForm<FormData>({ resolver: yupResolver(validationSchema) });
 
  const getSubscriptionDetailFn = async () => {
    setLoading(true);
    try {
      let response = await getSubscriptionDetail(subscriptionId);
      response = JSON.parse(JSON.stringify(response));
      const { name, enName, description, enDescription } = response;
      setData(response);
      setValue('name', name);
      setValue('enName', enName);
      setValue('description', description);
      setValue('enDescription', enDescription);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(subscriptionId){
      getSubscriptionDetailFn();
    }
  }, []);

  const saveSubscriptionFn = handleSubmit(async (values) => {
    setLoading(true);
    try {
      await updateSubscription({ ...values, id: data?.objectId });
      showSuccess('Subscription updated successfully.');
      props.history.goBack();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });

  const getHeader = () => {
    return(
      <div className={styles['header']}>
        <div className={styles['heading']}>Update Subscription</div>
      </div>
    );
  };

  const getFooter = () => {
    return(
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Save'}
          active={!loading}
          isLoading={loading}
          onClick={saveSubscriptionFn}
        />
      </div>
    );
  };
  
  const getFieldError = (error) => {
    if(!error) return null;
    return(
      <Error message={error} />
    );
  };

  const getName = () => {
    return(
      <div className={`${styles['name']} mr-2`}>
        <div className={styles['label']}>Name*</div>
        <input
          name={'name'}
          ref={register}
          className={'form-control'}
          disabled={loading}
          placeholder="Enter name(Spanish)"
        />
        {getFieldError(errors?.name?.message)}
      </div>
    );
  };

  const getDescription = () => {
    return(
      <div className={styles['description']}>
        <div className={styles['label']}>Description*</div>
        <textarea
          name={'description'}
          ref={register}
          className={'form-control'}
          disabled={loading}
          placeholder="Enter Description(Spanish)"
        />
        {getFieldError(errors?.description?.message)}
      </div>
    );
  };

  const getEnName = () => {
    return(
      <div className={styles['name']}>
        <div className={styles['label']}>English Name</div>
        <input
          name={'enName'}
          ref={register}
          className={'form-control'}
          disabled={loading}
          placeholder="Enter Name(English)"
        />
        {getFieldError(errors?.enName?.message)}
      </div>
    );
  };

  const getEnDescription = () => {
    return(
      <div className={styles['description']}>
        <div className={styles['label']}>English Description</div>
        <textarea
          name={'enDescription'}
          ref={register}
          className={'form-control'}
          disabled={loading}
          placeholder="Enter Description(English)"
        />
        {getFieldError(errors?.enDescription?.message)}
      </div>
    );
  };

  return (
    <div className={styles['main-container']}>
      {getHeader()}
      <div className={styles['item-details']}>
        {getName()}
        {getDescription()}
        {getEnName()}
        {getEnDescription()}
      </div>
      {getFooter()}
    </div>
  );
};

export default EditSubscription;
